"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("../Text/constant");
var _constants = require("./constants");
var _default = {
  PropTypes: {
    data: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,
    title: _propTypes.string,
    type: (0, _propTypes.oneOf)(Object.values(_constants.PARAGRAPH_TYPES)),
    color: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    fontSize: (0, _propTypes.oneOf)(_constant.ARR_FONT_SIZE),
    textAlign: (0, _propTypes.oneOf)(_constant2.TEXT_ALIGN),
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    titleType: _propTypes.string,
    titleMargin: _propTypes.string,
    titleAlign: _propTypes.string,
    titleColor: _propTypes.string,
    bulletColor: _propTypes.string
  },
  DefaultProps: {
    type: _constants.PARAGRAPH_TYPES.NORMAL,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    color: _constants.DEFAULT_STYLE.DEFAULT_TEXT_COLOR,
    fontSize: _constants.DEFAULT_STYLE.DEFAULT_FONT_SIZE,
    titleType: _constants.DEFAULT_STYLE.DEFAULT_TITLE_TYPE,
    titleMargin: _constants.DEFAULT_STYLE.DEFAULT_MARGIN_BOTTOM,
    titleColor: _constants.DEFAULT_STYLE.DEFAULT_TITLE_COLOR
  }
};
exports.default = _default;